/** Tooltip for API-masked values (e.g. employee ID, SSN). */
export const MASKED_SENSITIVE_FIELD_TOOLTIP = 'Field masked due to possible sensitive data';

/** True when the value looks like a display mask (contains `*`, `x`, or `X`). */
export function isMaskedDisplayValue(raw: string | undefined | null): boolean {
  if (raw == null) return false;
  const s = String(raw).trim();
  return s !== '' && /[*xX]/.test(s);
}

function digitsOnly(s: string): string {
  return s.replace(/\D/g, '');
}

/**
 * True when the API returned a display mask (e.g. `***-**-9931`), not a full 9-digit SSN.
 * Masked values must not be digit-stripped into the edit form or PATCH diff baseline.
 */
export function isMaskedMemberSsn(raw: string | undefined | null): boolean {
  if (isMaskedDisplayValue(raw)) return true;
  if (raw == null) return false;
  const s = String(raw).trim();
  if (s === '') return false;
  const digits = digitsOnly(s);
  return digits.length > 0 && digits.length < 9 && /\D/.test(s);
}

/** Edit/diff baseline: empty when masked; otherwise up to 9 digits only. */
export function ssnDigitsForMemberEditBaseline(raw: string | undefined | null): string {
  if (isMaskedMemberSsn(raw)) return '';
  return digitsOnly(raw ?? '').slice(0, 9);
}
